import { makeAutoObservable, runInAction } from 'mobx'
import { demo } from 'page/catalog/store/CatalogStore'
import { api } from 'store/api'
import { ClientCheckRequest } from 'type/client'
import { validateEmail } from 'util/form'
import { normalizePhone } from 'util/phone'
import { delay } from 'util/promise'

type State = 'unknown' | 'short_phone' | 'short_card' | 'invalid' | 'exists' | 'good'

export class PhoneStore {
  private sequence = 0
  private version = 0
  private company: string

  state: State = 'unknown'
  text: string = ''

  constructor(company: string) {
    this.company = company
    makeAutoObservable(this)
  }

  get phone(): string {
    return normalizePhone(this.text)
  }

  get email(): string {
    return this.text.replaceAll(/\s+/g, '')
  }

  get card(): string {
    return this.text.replaceAll(/\s+/g, '')
  }

  get good(): boolean {
    return this.state === 'good'
  }

  change(text: string | null | undefined) {
    const be = demo.it.by_email
    const bc = demo.it.by_card
    text = text || ''
    if (be) {
      text = text.replaceAll(/\s/g, '')
    } else if (bc) {
      text = text.replaceAll(/\s/g, '')
    } else {
      text = text.replaceAll(/[^\s\d+-]/g, '')
    }
    if (this.text === text) return

    this.text = text
    this.recheck(1000)
  }

  enter() {
    if (this.version < this.sequence) this.recheck()
  }

  private async recheck(ms?: number) {
    const be = demo.it.by_email
    const bc = demo.it.by_card
    const v = ++this.sequence
    const { company, phone, email, card } = this

    let request: ClientCheckRequest
    if (be) {
      request = { company, email }
      if (!validateEmail(email)) {
        return runInAction(() => this.state = 'invalid')
      }
    } else if (bc) {
      request = { company, card }
      if (card.length < 4) {
        return runInAction(() => this.state = 'short_card')
      }
    } else {
      request = { company, phone }
      if (phone.length < 6) {
        return runInAction(() => this.state = 'short_phone')
      }
    }

    this.state = 'unknown'

    if (ms) await delay(ms)
    if (v !== this.sequence) return

    this.version = v

    const exists = await api.checkUser(request)
    if (v !== this.sequence) return

    runInAction(() => this.state = exists ? 'exists' : 'good')
  }
}
